import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type SessionService from 'walden-trace-app/services/session';

export default class LoginController extends Controller {
  @service('session') declare sessionService: SessionService;

  queryParams = ['attemptedURL'];

  @action
  login() {
    void this.sessionService.redirectToLogin();
  }
}
